import React, { Component } from 'react';
import { connect } from "react-redux";
import { withTranslation } from 'react-i18next';
import ScrollToBottom from 'react-scroll-to-bottom';
import {css} from "@emotion/css";
import ChatMessages from "./ChatMessages";
import {firstLetterSub, firstLetterText, getIDForColor} from "../../lib/helper";
import ChatFooter from "./ChatFooter";
import {generateRandomAvatarOptions} from "../../lib/generateRandomAvatarOptions";
import Avatar from "avataaars";
import {helperFunctions} from "../../lib/helperFunctions";
import { toast } from 'react-toastify';
import API from "../../lib/api"

@connect((store) => {
    return {
        chatprop: store.chatprop
    };
})
class ChatDetail extends Component {

    constructor(props) {
        super(props);

        this.state={
          "active_sidebar":true
        };
        this.chatTransfer=this.chatTransfer.bind(this);
        this.changeStateSidebar=this.changeStateSidebar.bind(this);
        helperFunctions.eventEmitter.addListener('read_message', (e) => this.readMessage(e));
		
		this.countMessage = 0;
		
		this.deleteBadRate=this.deleteBadRate.bind(this);
    }
	
	deleteBadRate(e){

		
		
		var formData = new FormData();
        formData.append("chat_id", this.props.id);
		API.post("chat/deleteBadRate",formData).then((response) => {
			if (response.status === 200) {
				
				if(response.data.message.status == true){
					toast.success('Success');
				}
				
				if(response.data.message.status == false){
                        toast.error(response.data.message.error);
                }
				
			}else{
				toast.error("Invalid Request!!!!");
			}
		}).catch((error) => {
			toast.error("Invalid Request!!!");
		});	
		
		

	}
    readMessage = (e) => {

        if(typeof e.chat_id!=="undefined"){
            if(e.chat_id==this.props.id){

                NODECONNECT.socket.emit("adminReadMessage",{"i":this.props.id});

            }
        }
    }
    shouldComponentUpdate(nextProps, nextState, nextContext) {
        if (this.props.id!=="undefined") {
            return true;
        }
        return false;
    }
	componentDidUpdate(prevProps) {
		
		if(this.props.chat.messages.length != this.countMessage)
		$(".chatScroll>div").scrollTop($(".chatScroll>div")[0].scrollHeight);

		this.countMessage = this.props.chat.messages.length;
	}
    changeStateSidebar(){
        this.setState({
            "active_sidebar":!this.state.active_sidebar
        })
    }
    chatTransfer(e,id){
        this.props.dispatch({
            type: 'SET_MODAL',
            data: {
                "show":true,
                "page":"chatTransfer",
                "data":{
                    id :id
                }
            }
        });
        e.preventDefault();
    }

    componentWillUnmount() {
        this.props.id=undefined;
    }

    render() {
        const { t } = this.props;
		
		//console.log(this.props);
		
        const ROOT_CSS = css({
            height: "100%",
            width: "100%"
        });
                return (
                    <React.Fragment>
                    <div className="chat">
                        <div className="chat-header">
                            <div className="user-details">
                                <div className="d-lg-none ml-2">
                                    <ul className="list-inline mt-2 mr-2">
                                        <li className="list-inline-item">
                                            <a className="text-muted px-0 left_side" href="#" data-chat="open">
                                                <i className="fas fa-arrow-left"></i>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                <figure className="avatar ml-1">
                                    <div className="avatar">
                                        <div className="letter-avatar ">
                                            <Avatar
                                                style={{ width: 'auto', height: 'auto' }}
                                                avatarStyle='Circle'
                                                {...generateRandomAvatarOptions(this.props.chat.random) } />
                                        </div>
                                    </div>
                                </figure>
                                <div className="mt-1">
                                    <h5 style={{ "float": "left", "cursor": "pointer" }} onClick={() => {navigator.clipboard.writeText(this.props.chat.user_name); toast.success("Username Copied!");}}>{firstLetterText(this.props.chat.user_name)}</h5>
									<h5 style={{ "float": "left" }}>
									{typeof this.props.chat.userData !== "undefined" &&
									<>
									
									{this.props.chat.userData.location.includes('itemci.com') &&
									<>
									<a style={{ "margin-left": "5px" }} target="_blank" href={"https://itemci.com/xkibmqveoho/users/go/"+this.props.chat.user_name}>Profile Git</a>
									<img src={"/Public/images/itemciLogo.png"} style={{ "margin-left": "10px", height: '25px', width: 'auto' }} />
									</>
									}
									
									{this.props.chat.userData.location.includes('oyuncudan.com') &&
									<>
									<a style={{ "margin-left": "5px" }} target="_blank" href={"https://oyuncudan.com/zero/users/go/"+this.props.chat.user_name}>Profile Git</a>
									<img src={"/Public/images/oyuncudanLogo.png"} style={{ "margin-left": "10px", height: '25px', width: 'auto' }} />
									</>
									}
									
									</>
									}
									</h5>
                                </div>
                            </div>

                            <div className="chat-options">
                                <ul className="list-inline">
                                    <li className="list-inline-item customer_detail" data-toggle="tooltip" title=""
                                        data-original-title="Profile">
                                        <a
                                            onClick={this.changeStateSidebar.bind(this)}
                                            className="btn btn-outline-light">
                                            <i className="bx bx-user-circle"></i>
                                        </a>
                                    </li>
                                    {this.props.type == "active" && this.props.chat.user_closed==0 &&
                                    <li className="list-inline-item">
                                        <a className="btn btn-outline-light" href="#" data-toggle="dropdown">
                                            <i className="bx bx-dots-horizontal"></i>
                                        </a>
                                        <div className="dropdown-menu dropdown-menu-right">
                                            {typeof this.props.chat.supervised !== "undefined" &&
                                            <React.Fragment>
                                                {this.props.chat.supervised === 1 &&
                                                <a href="#" className="closeChat dropdown-item"
                                                   onClick={e=>this.props.closeSupervised(e, this.props.chat.id,this.props.chat.user_closed)}>Stop supervising<span>
                                                <i className="bx bx-stop"></i></span></a>
                                                }
                                            </React.Fragment>
                                            }
                                            {(typeof this.props.chat.supervised === "undefined" || this.props.chat.supervised === 0) &&
                                                <React.Fragment>

                                            <a href="#" className="closeChat dropdown-item"
                                               onClick={e => this.props.closeChat(e, this.props.id)}>Close
                                                Chat <span>
                                                <i className="bx bx-trash"></i></span></a>
												
											<a href="#" className="userBan dropdown-item"
                                               onClick={e => this.props.userBan(e, this.props.id)}>User Ban <span>
                                                <i className="bx bx-block"></i></span></a>

                                                <a href="#" className="dropdown-item"
                                                onClick={e => this.chatTransfer(e, this.props.id)}>Chat Transfer <span><i
                                                className='bx bx-transfer'></i></span></a>
                                                </React.Fragment>
                                            }


                                        </div>
                                    </li>
                                    }
                                </ul>
                            </div>


                        </div>

                        <div className="chat-body">
                            <ScrollToBottom className={"chatScroll "+ROOT_CSS} initialScrollBehavior={'auto'}>
                            <div className="messages " id="chat-messages">
                                {typeof this.props.chat.messages !== "undefined" &&
                                    <ChatMessages chat={this.props.chat} messages={this.props.chat.messages} id={this.props.id}/>
                                }
                            </div>
                            </ScrollToBottom>
                        </div>
                      <ChatFooter id={this.props.id} chat={this.props.chat}/>
                    </div>
                     <div className={"right-sidebar right_sidebar_profile "+(this.state.active_sidebar===true? "active_sidebar" : "")} >
                            <div className="right-sidebar-wrap active">
                                <div className="left-chat-title d-flex justify-content-between align-items-center p-3">
                                    <div className="chat-title">
                                        <h4>DETAİLS</h4>
                                    </div>
                                    <div className="contact-close_call text-right">
                                        <a href="#"
                                           onClick={this.changeStateSidebar.bind(this)}
                                           className="close_profile close_profile4">
                                            <i className='bx bx-x'></i>
                                        </a>
                                    </div>
                                </div>
                                <div className="sidebar-body">
                                    <div className="mt-0 right_sidebar_logo">
                                        <div className="user-detail-card">
                                            <div className="user-details-card-title">General Info</div>
                                            <div className="user-details">
                                                <figure className="avatar ">
                                                    <div className="avatar">
                                                        <div className="letter-avatar">
                                                            <Avatar
                                                                style={{ width: 'auto', height: 'auto' }}
                                                                avatarStyle='Circle'
                                                                {...generateRandomAvatarOptions(this.props.chat.random) } />
                                                        </div>
                                                    </div>
                                                </figure>
                                                <div className="mt-1">
                                                    <h5>{firstLetterText(this.props.chat.user_name)}</h5>
                                                    <small>
                                                        {typeof this.props.chat.userData !== "undefined" &&
                                                            <>
                                                                {typeof this.props.chat.userData.chatform !== "undefined" &&
                                                                    <>
                                                                                {typeof this.props.chat.userData.chatform.email !== "undefined" &&
                                                                                      this.props.chat.userData.chatform.email
                                                                                }

                                                                    </>
                                                                }

                                                            </>
                                                        }
                                                    </small>
                                                </div>
                                            </div>


                                            <div className="map-info">

                                                <div className="mr-4">
                                                    <i className='bx bxs-map'></i>
                                                </div>
                                                <div>
                                                    {this.props.chat.userData.cityName} {this.props.chat.userData.countryName} / {this.props.chat.userData.postalCode}

                                                </div>
                                            </div>
                                           {/* <div>
                                                <iframe className="google-map-iframe"
                                                        src="https://www.google.com/maps/embed/v1/place?key=AIzaSyDQTMnzd1j35ErtbKkFHH0G32zIohahY0Y&amp;q={{$chat['userData']['locationLatitude']}},{{$chat['userData']['locationLongitude']}}&amp;zoom=12"></iframe>
										   </div>*/}

                                        </div>

                                        <div className="user-detail-card">
                                            <div className="user-details-card-title">Pre-chat form</div>
                                            <div className="mt-2">
                                                {typeof this.props.chat.userData.chatform !== "undefined" &&
                                                    <>
                                                        {Object.keys(this.props.chat.userData.chatform).length > 0 &&
                                                            <>
                                                                {Object.keys(this.props.chat.userData.chatform).map((k)=>{
                                                                     return  <div className="chat-form-info">{this.props.chat.userData.chatform[k].name} <br/> {this.props.chat.userData.chatform[k].val}</div>
                                                                 })}
                                                            </>
                                                        }
                                                    </>
                                                }

                                                {typeof this.props.chat.vote !== "undefined" &&
                                                <React.Fragment>
                                                    {typeof this.props.chat.vote.vote !== "undefined" &&
                                                    <div>
                                                        {this.props.chat.vote.vote == 2 &&
                                                        <React.Fragment>
                                                            <span className="chatVoteDown"></span>
                                                            <small> {firstLetterText(this.props.chat.user_name)} rated the chat as bad</small>

                                                        </React.Fragment>

                                                        }
                                                        {this.props.chat.vote.vote == 1 &&
                                                        <React.Fragment>
                                                            <span className="chatVoteUp"></span>
                                                            <small>{firstLetterText(this.props.chat.user_name)} rated the chat as good</small>
                                                        </React.Fragment>
                                                        }

                                                        {typeof this.props.chat.vote.message !== "undefined" &&
                                                            <React.Fragment>
                                                                {this.props.chat.vote.message != "" &&
                                                                <small className="mt-2"> {firstLetterText(this.props.chat.user_name)} left the following comment: <br/>
                                                                <i>{this.props.chat.vote.message}</i>
                                                                </small>
                                                                }
                                                            </React.Fragment>

                                                        }

                                                    </div>
                                                    }
                                                </React.Fragment>
                                                }
                                            </div>

                                        </div>
                                        <div className="user-detail-card">
                                            <div className="user-details-card-title">Technology</div>
                                            <div className="chat-form-info">IP address&nbsp;: {this.props.chat.userData.ip}</div>
                                            <div
                                                className="chat-form-info">OS/Device&nbsp;: {this.props.chat.userData.os_title} / {this.props.chat.userData.device_type}</div>
                                            <div
                                                className="chat-form-info">Browser&nbsp;: {this.props.chat.userData.browser_name}({this.props.chat.userData.browser_version})
                                            </div>
                                        </div>
										
										{(this.props.chatprop.operator['role'] == 1 || this.props.chatprop.operator['role'] == 2) && typeof this.props.chat.vote !== "undefined" && typeof this.props.chat.vote.vote !== "undefined" && this.props.chat.vote.vote == 2 &&
										<div className="user-detail-card">
                                            
								<button style={{ width:"100%",height: "100%"}} type="button" className="chat-button chat-button-success ml-1"
								onClick={this.deleteBadRate.bind(this)}
								>
									<span>DELETE BAD RATE</span>
								</button>
											
                                        </div>
										}
										
                                    </div>
                                </div>
                            </div>
                        </div>
                    </React.Fragment>
                );


    }
}

export default withTranslation()(ChatDetail);
